import { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { onUpdateAvailable, applyUpdate } from "../lib/swUpdate";

// Aviso discreto: "Hay una nueva versión" · el usuario decide cuándo actualizar (nunca en medio de una venta)
export default function UpdateBanner() {
  const [ready, setReady] = useState(false);
  const [hidden, setHidden] = useState(false);
  useEffect(() => onUpdateAvailable(setReady), []);
  if (!ready || hidden) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[80] flex items-center gap-3 rounded-2xl bg-slate-900 text-white shadow-2xl border border-emerald-500/40 pl-4 pr-2 py-2.5 animate-in slide-in-from-bottom-4" data-testid="update-banner">
      <Sparkles size={18} className="text-emerald-400 shrink-0" />
      <div className="text-sm leading-tight">
        <div className="font-bold">Hay una nueva versión</div>
        <div className="text-[11px] text-slate-300">Toca para actualizar cuando termines lo que estás haciendo.</div>
      </div>
      <button type="button" onClick={() => applyUpdate()} className="ml-1 h-9 px-3 rounded-lg bg-emerald-500 hover:bg-emerald-600 font-bold text-sm" data-testid="update-apply">Actualizar</button>
      <button type="button" onClick={() => setHidden(true)} className="h-9 w-9 grid place-items-center rounded-lg text-slate-400 hover:text-white" title="Más tarde" data-testid="update-later"><X size={16} /></button>
    </div>
  );
}
